import { definitions } from "./interbtc-types";
export default {
    types: definitions.types[0].types,
    rpc: parseProviderRpcDefinitions(definitions.rpc),
    providerRpc: definitions.rpc,
};
function parseProviderRpcDefinitions(rpcDefs) {
    const parsedDefs = {};
    for (const module in rpcDefs) {
        const definitions = rpcDefs[module];
        for (const definitionName in definitions) {
            const definitionBody = definitions[definitionName];
            const decoratedDefinitionBody = Object.assign(Object.assign({}, definitionBody), { aliasSection: module });
            parsedDefs[definitionName] = decoratedDefinitionBody;
        }
    }
    return parsedDefs;
}
//# sourceMappingURL=definitions.js.map